// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.header {
	position: fixed;
	top: 0;
	left: 0;
	width: 100%;
	height: 80px;
	background: black;
	box-shadow: 1px 0 2px rgba(0, 0, 0, 0.125);
	display: flex;
	align-items: center;
	z-index: 100;
}

.header .logo {
	width: 280px;
	padding: 0 25px;
	color: white;
	letter-spacing: 2px;
	text-transform: uppercase;
	border-right: 1px solid #f5f5f5;

}

.header .logo img {
	height: 25px !important;
}

.header .menu {
	width: calc(100% – 250px);
	padding: 0 25px;
	display: flex;
	justify-content: space-between;
	align-items: center;
}

.header .hamburger {
	font-size: 20px;
	cursor: pointer;
	color: white;
	position: absolute;
	top: 22px;
}

.header .hamburger:hover {
	color: #3894ad;
}

.header .header-menu {

	width: calc(100vw - 305px);
	padding-right: 25px;
}

.header .header-menu .access-oof,
.header .header-menu .download-report {
	color: white;
	float: right;
	padding: 0px 25px;
	border-right: solid 1px white;
	cursor: pointer;
	font-weight: 500;
	margin: 28px 0px;
}

.header .header-menu .access-oof>svg,
.header .header-menu .download-report>svg {
	margin-bottom: 3px;
	margin-right: 4px;
}

.header .header-menu .download-report:hover,
.header .header-menu .access-oof:hover {
	color: #3894ad;
}

.user {
	color: white;
	float: right;
	padding: 0px 25px;
	font-weight: 400;
	margin-left: 70px;

}

.user svg {
	color: white;
	font-size: 20px;
}

.user .dropdown .userIcon {
	margin-right: 5px;
	background-color: #2489a5;
	font-size: 10px;
	height: 20px;
	width: 20px;
	border-radius: 10px;
}

.dropdown {
	float: right;
	position: relative;
	cursor: pointer;
}

.dropdown-content {
	display: none;
	position: absolute;
	right: 0;
	background-color: #e7e7e7;
	min-width: 210px;
	box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
	z-index: 1;
}

.dropdown-content a {
	color: black;
	padding: 12px 16px;
	text-decoration: none;
	display: block;
}

.dropdown-content a:hover {
	background-color: #f1f1f1;
}

.dropdown-content svg {
	color: black;
	font-size: 20px;
}

.dropdown:hover .dropdown-content {
	display: block;
}

.dropdown .dropbtn {
	padding: 28px 0px;
}

.upload-file .title {
	background-color: #e7e7e7;
	color: black !important;
	padding: 10px;
	margin-bottom: 20px;
	font-weight: bold;
}

.upload-file .btn-primary {
	background-color: #2489a5;
	border: solid 1px #2489a5;
}

.upload-file .btn-primary:hover,
.upload-file .btn-primary:active {
	background-color: #27687a;
	border: solid 1px #27687a;
}

.upload-file .btn-primary svg,
.close svg {
	margin-bottom: 3px;
	margin-left: 3px;
}

.upload-file input {
	margin-top: 2px;
}

.upload-file .input-group {
	overflow: hidden;
}

.upload {
	float: right;
	margin-bottom: 13px;
}

.choose {
	background-color: #d9d9d9 !important;
}

.choose:hover,
.choose:active {
	background-color: #d9d9d9;
}

input[type=file] {
	font-size: 42px;
	position: absolute;
	left: 0;
	top: 0;
	opacity: 0;
	display: none;
}

.text {
	white-space: nowrap;
}

.error-message {
	color: red;
	font-size: 12px;
	margin-top: 5px;
}

.form-label-sm {
	font-size: 12px;
	font-weight: bold;
}`, "",{"version":3,"sources":["webpack://./src/pages/Layout/header.css"],"names":[],"mappings":"AAAA;CACC,eAAe;CACf,MAAM;CACN,OAAO;CACP,WAAW;CACX,YAAY;CACZ,iBAAiB;CACjB,0CAA0C;CAC1C,aAAa;CACb,mBAAmB;CACnB,YAAY;AACb;;AAEA;CACC,YAAY;CACZ,eAAe;CACf,YAAY;CACZ,mBAAmB;CACnB,yBAAyB;CACzB,+BAA+B;;AAEhC;;AAEA;CACC,uBAAuB;AACxB;;AAEA;CACC,yBAAyB;CACzB,eAAe;CACf,aAAa;CACb,8BAA8B;CAC9B,mBAAmB;AACpB;;AAEA;CACC,eAAe;CACf,eAAe;CACf,YAAY;CACZ,kBAAkB;CAClB,SAAS;AACV;;AAEA;CACC,cAAc;AACf;;AAEA;;CAEC,0BAA0B;CAC1B,mBAAmB;AACpB;;AAEA;;CAEC,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,6BAA6B;CAC7B,eAAe;CACf,gBAAgB;CAChB,gBAAgB;AACjB;;AAEA;;CAEC,kBAAkB;CAClB,iBAAiB;AAClB;;AAEA;;CAEC,cAAc;AACf;;AAEA;CACC,YAAY;CACZ,YAAY;CACZ,iBAAiB;CACjB,gBAAgB;CAChB,iBAAiB;;AAElB;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,iBAAiB;CACjB,yBAAyB;CACzB,eAAe;CACf,YAAY;CACZ,WAAW;CACX,mBAAmB;AACpB;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,eAAe;AAChB;;AAEA;CACC,aAAa;CACb,kBAAkB;CAClB,QAAQ;CACR,yBAAyB;CACzB,gBAAgB;CAChB,+CAA+C;CAC/C,UAAU;AACX;;AAEA;CACC,YAAY;CACZ,kBAAkB;CAClB,qBAAqB;CACrB,cAAc;AACf;;AAEA;CACC,yBAAyB;AAC1B;;AAEA;CACC,YAAY;CACZ,eAAe;AAChB;;AAEA;CACC,cAAc;AACf;;AAEA;CACC,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,uBAAuB;CACvB,aAAa;CACb,mBAAmB;CACnB,iBAAiB;AAClB;;AAEA;CACC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;CAEC,yBAAyB;CACzB,yBAAyB;AAC1B;;AAEA;;CAEC,kBAAkB;CAClB,gBAAgB;AACjB;;AAEA;CACC,eAAe;AAChB;;AAEA;CACC,gBAAgB;AACjB;;AAEA;CACC,YAAY;CACZ,mBAAmB;AACpB;;AAEA;CACC,oCAAoC;AACrC;;AAEA;;CAEC,yBAAyB;AAC1B;;AAEA;CACC,eAAe;CACf,kBAAkB;CAClB,OAAO;CACP,MAAM;CACN,UAAU;CACV,aAAa;AACd;;AAEA;CACC,mBAAmB;AACpB;;AAEA;CACC,UAAU;CACV,eAAe;CACf,eAAe;AAChB;;AAEA;CACC,eAAe;CACf,iBAAiB;AAClB","sourcesContent":[".header {\n\tposition: fixed;\n\ttop: 0;\n\tleft: 0;\n\twidth: 100%;\n\theight: 80px;\n\tbackground: black;\n\tbox-shadow: 1px 0 2px rgba(0, 0, 0, 0.125);\n\tdisplay: flex;\n\talign-items: center;\n\tz-index: 100;\n}\n\n.header .logo {\n\twidth: 280px;\n\tpadding: 0 25px;\n\tcolor: white;\n\tletter-spacing: 2px;\n\ttext-transform: uppercase;\n\tborder-right: 1px solid #f5f5f5;\n\n}\n\n.header .logo img {\n\theight: 25px !important;\n}\n\n.header .menu {\n\twidth: calc(100% – 250px);\n\tpadding: 0 25px;\n\tdisplay: flex;\n\tjustify-content: space-between;\n\talign-items: center;\n}\n\n.header .hamburger {\n\tfont-size: 20px;\n\tcursor: pointer;\n\tcolor: white;\n\tposition: absolute;\n\ttop: 22px;\n}\n\n.header .hamburger:hover {\n\tcolor: #3894ad;\n}\n\n.header .header-menu {\n\n\twidth: calc(100vw - 305px);\n\tpadding-right: 25px;\n}\n\n.header .header-menu .access-oof,\n.header .header-menu .download-report {\n\tcolor: white;\n\tfloat: right;\n\tpadding: 0px 25px;\n\tborder-right: solid 1px white;\n\tcursor: pointer;\n\tfont-weight: 500;\n\tmargin: 28px 0px;\n}\n\n.header .header-menu .access-oof>svg,\n.header .header-menu .download-report>svg {\n\tmargin-bottom: 3px;\n\tmargin-right: 4px;\n}\n\n.header .header-menu .download-report:hover,\n.header .header-menu .access-oof:hover {\n\tcolor: #3894ad;\n}\n\n.user {\n\tcolor: white;\n\tfloat: right;\n\tpadding: 0px 25px;\n\tfont-weight: 400;\n\tmargin-left: 70px;\n\n}\n\n.user svg {\n\tcolor: white;\n\tfont-size: 20px;\n}\n\n.user .dropdown .userIcon {\n\tmargin-right: 5px;\n\tbackground-color: #2489a5;\n\tfont-size: 10px;\n\theight: 20px;\n\twidth: 20px;\n\tborder-radius: 10px;\n}\n\n.dropdown {\n\tfloat: right;\n\tposition: relative;\n\tcursor: pointer;\n}\n\n.dropdown-content {\n\tdisplay: none;\n\tposition: absolute;\n\tright: 0;\n\tbackground-color: #e7e7e7;\n\tmin-width: 210px;\n\tbox-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);\n\tz-index: 1;\n}\n\n.dropdown-content a {\n\tcolor: black;\n\tpadding: 12px 16px;\n\ttext-decoration: none;\n\tdisplay: block;\n}\n\n.dropdown-content a:hover {\n\tbackground-color: #f1f1f1;\n}\n\n.dropdown-content svg {\n\tcolor: black;\n\tfont-size: 20px;\n}\n\n.dropdown:hover .dropdown-content {\n\tdisplay: block;\n}\n\n.dropdown .dropbtn {\n\tpadding: 28px 0px;\n}\n\n.upload-file .title {\n\tbackground-color: #e7e7e7;\n\tcolor: black !important;\n\tpadding: 10px;\n\tmargin-bottom: 20px;\n\tfont-weight: bold;\n}\n\n.upload-file .btn-primary {\n\tbackground-color: #2489a5;\n\tborder: solid 1px #2489a5;\n}\n\n.upload-file .btn-primary:hover,\n.upload-file .btn-primary:active {\n\tbackground-color: #27687a;\n\tborder: solid 1px #27687a;\n}\n\n.upload-file .btn-primary svg,\n.close svg {\n\tmargin-bottom: 3px;\n\tmargin-left: 3px;\n}\n\n.upload-file input {\n\tmargin-top: 2px;\n}\n\n.upload-file .input-group {\n\toverflow: hidden;\n}\n\n.upload {\n\tfloat: right;\n\tmargin-bottom: 13px;\n}\n\n.choose {\n\tbackground-color: #d9d9d9 !important;\n}\n\n.choose:hover,\n.choose:active {\n\tbackground-color: #d9d9d9;\n}\n\ninput[type=file] {\n\tfont-size: 42px;\n\tposition: absolute;\n\tleft: 0;\n\ttop: 0;\n\topacity: 0;\n\tdisplay: none;\n}\n\n.text {\n\twhite-space: nowrap;\n}\n\n.error-message {\n\tcolor: red;\n\tfont-size: 12px;\n\tmargin-top: 5px;\n}\n\n.form-label-sm {\n\tfont-size: 12px;\n\tfont-weight: bold;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
